import { render } from "./Charts.vue?vue&type=template&id=23cada25&scoped=true"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"

import "./Charts.vue?vue&type=style&index=0&id=23cada25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cada25"]])

export default __exports__